// extracted by mini-css-extract-plugin
export default {"nav_menu":"ToggleIcon_nav_menu__R7VTB","span1":"ToggleIcon_span1__hxjx5","span2":"ToggleIcon_span2__W6-Nq","span3":"ToggleIcon_span3__Y6DOh","active":"ToggleIcon_active__weXdU"};